(() => {
  if (customElements.get('cart-holiday')) return;
  let paused = false;
  try { paused = sessionStorage.getItem('impact-cart-snow-paused') === 'true'; } catch (_) {}
  class CartHoliday extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-snow-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.refresh = () => {
        this.toggleAttribute('data-snow-running', !paused && !this.motion.matches && !document.hidden);
        this.button.hidden = this.motion.matches;
        this.button.textContent = paused ? this.button.dataset.resume : this.button.dataset.pause;
      };
      this.toggle = () => {
        paused = !paused;
        try { sessionStorage.setItem('impact-cart-snow-paused', String(paused)); } catch (_) {}
        document.dispatchEvent(new Event('impact:cart-snow'));
      };
      this.button.addEventListener('click', this.toggle);
      this.motion.addEventListener('change', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      document.addEventListener('impact:cart-snow', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.toggle);
      this.motion.removeEventListener('change', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
      document.removeEventListener('impact:cart-snow', this.refresh);
    }
  }
  customElements.define('cart-holiday', CartHoliday);
})();
